// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trans[data-v-25099b85]{-webkit-transform:scale(1.3) translate(-1px,-1px);transform:scale(1.3) translate(-1px,-1px)}", ""]);
// Exports
module.exports = exports;
